import styled from 'styled-components';

import { Menu as MenuComponent } from '@pearsontechnology/aero-components';

export const Menu = styled(MenuComponent)`
  margin-top: 10px;
  word-break: normal;
  width: fit-content;
`;

export const MenuListItemText = styled.div`
  margin: 0 8px;
`;

export const Spacer = styled.div`
  width: 34px;
`;

export const MenuListItemWrapper = styled.div`
  cursor: ${(props) => props.activelyDownloadingReport ? 'no-drop': 'auto'};
`;